import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { CiriumWrapper } from '../../components/cirium/CiriumWrapper';
import { TravelerLoginCard } from './TravelerLoginCard';
import { sanitizeBrandingImageUrl } from '../brandingImageUtils';
import QueryString from 'qs';

/**
 * TravelerLoginPreviewContainer component to display the traveler login preview page.
 * @returns {JSX.Element} The TravelerLoginPreviewContainer component.
 */
const TravelerLoginPreviewContainer: React.FC = () => {
  const { search } = useLocation();
  const values = QueryString.parse(search) as Record<string, any>;

  return (
    <CiriumWrapper>
      <TravelerLoginCard
        handleLogin={() => {}}
        loading={true}
        showError={false}
        brandingImageUrl={sanitizeBrandingImageUrl(
          values['?brandingImageUrl'] || '',
        )}
      />
    </CiriumWrapper>
  );
};

export default TravelerLoginPreviewContainer;
